import React from 'react';
import { BrandAccent } from '../../constants/brandAccentConstants';
import { APPEARANCE_PANEL_INITIAL_FOCUS_ATTR } from '../../constants/appearancePanelConstants';
import { useTheme, type BrandAccent as BrandAccentType } from '../../context/ThemeContext';
import './BrandAccentToggle.css';

const OPTIONS: { value: BrandAccentType; label: string; short: string }[] = [
  { value: BrandAccent.HEALTHESUS, label: 'Default', short: 'Def' },
  { value: BrandAccent.BLUE, label: 'Blue', short: 'Blue' },
];

export interface BrandAccentToggleProps {
  /** When true, the first accent option is marked for portal Appearance popover initial focus. */
  markAppearancePanelInitialFocus?: boolean;
}

export const BrandAccentToggle: React.FC<BrandAccentToggleProps> = ({
  markAppearancePanelInitialFocus = false,
}) => {
  const { brandAccent, setBrandAccent } = useTheme();

  return (
    <div
      className="brand-accent-toggle"
      role="radiogroup"
      aria-label="Brand accent"
    >
      {OPTIONS.map((opt, index) => {
        const selected = brandAccent === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`brand-accent-toggle__btn brand-accent-toggle__btn--${opt.value} ${selected ? 'brand-accent-toggle__btn--active' : ''}`}
            {...(markAppearancePanelInitialFocus && index === 0
              ? { [APPEARANCE_PANEL_INITIAL_FOCUS_ATTR]: true }
              : {})}
            onClick={() => setBrandAccent(opt.value)}
          >
            <span className="brand-accent-toggle__label-full">{opt.label}</span>
            <span className="brand-accent-toggle__label-short">{opt.short}</span>
          </button>
        );
      })}
    </div>
  );
};